import React, { useEffect, useState } from 'react';
import styles from './Category.module.scss';
import Breadcrumbs from 'components/breadcrumbs';
import HeroSection from './hero-section';
import { TravelJournalCategoryProps } from './types';
import PopularArticles from './popular-articles';
import FeaturedArticle from './featured-article';
import ArticleGrid from '../home/article-grid/ArticleGrid';
import { Heading } from 'components/text';

const Category: React.FC<TravelJournalCategoryProps> = ({
  category,
  categories,
}) => {
  return (
    <main>
      <HeroSection categories={categories} selectedCategory={category} />
      <div className={styles.container}>
        <div className={styles.containerInner}>
          <section className={styles.breadCrumbContainer}>
            <Breadcrumbs
              setRouteList={() => [
                {
                  name: 'Travel Journal',
                  href: '/travel-journal',
                },
                {
                  name: category.name,
                  href: `/travel-journal/${category.slug}`,
                },
              ]}
            />
          </section>
          <PopularArticles articles={category.articles!.slice(0, 3)} />
        </div>
        <FeaturedArticle article={category.articles![3]} />
        <Heading as={'h3'} fontSize={28} className={styles.readMore}>
          Read next
        </Heading>
        <ArticleGrid
          articles={category.articles!.slice(4, 10)}
          showWide={false}
        />
      </div>
    </main>
  );
};

export default Category;
